export default "__VITE_ASSET__Bqm8iNY6__"